// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--30SPh","namedGrid":"styles-module--namedGrid--FbJqZ","twoColumns":"styles-module--twoColumns--1NSqw"};